// Financial Overview Tour Class Names
export const FINANCIAL_OVERVIEW_TOUR_CLASSES = {
  HEADER: 'financial-overview-header',
  TABS_LIST: 'financial-tabs-list',
  TAB_FRANCHISEE_FEE: 'financial-tab-franchisee-fee',
  TAB_INITIAL_INVESTMENT: 'financial-tab-initial-investment',
  TAB_ROYALTIES: 'financial-tab-royalties',
  TAB_PERFORMANCE: 'financial-tab-performance',
  TAB_PROJECTION: 'financial-tab-projection',
  FDD_DOCUMENT_VIEWER: 'fdd-document-viewer',
  FDD_PAGE_INDICATOR: 'fdd-page-indicator',
} as const;

// Home Tour Class Names
export const HOME_TOUR_CLASSES = {
  PROFILE_BUTTON: 'home-profile-button',
  ESTIMATED_TIMELINE: 'home-estimated-timeline',
  SEARCHING_USERS: 'home-searching-users',
  CURRENT_DISCOVERY_STEP: 'home-current-discovery-step',
  REFER_BUTTON: 'home-refer-button',
  STAGE_ITEM_CHECKBOX: 'home-stage-item-checkbox',
  LIKED_TERRITORIES: 'home-liked-territories',
  AIMEI_CHAT_BOX: 'home-aimei-chat-box',
  SIDEBAR_HOME_BUTTON: 'home-sidebar-home-button',
  SIDEBAR_DISCOVERY_PARENT_BUTTON: 'home-sidebar-discovery-parent-button',
  SIDEBAR_DISCOVERY_STAGE_1_BUTTON: 'home-sidebar-discovery-stage-1-button',
  SIDEBAR_TERRITORIES_BUTTON: 'home-sidebar-territories-button',
  SIDEBAR_FINANCIAL_OVERVIEW_BUTTON: 'home-sidebar-financial-overview-button',
  SIDEBAR_LIBRARY_BUTTON: 'home-sidebar-library-button',
  SIDEBAR_ASK_AIMEI_BUTTON: 'home-sidebar-ask-aimei-button',
  SIDEBAR_QUICK_LINK_1_BUTTON: 'home-sidebar-quick-link-1-button',
} as const;

// Library Tour Class Names
export const LIBRARY_TOUR_CLASSES = {
  PAGE_HEADER: 'library-page-header',
  MAIN_TABS: 'library-main-tabs',
  DOCUMENTS_TAB: 'library-documents-tab',
  CONTACTS_TAB: 'library-contacts-tab',
  DOCUMENTS_SUB_TABS: 'documents-sub-tabs',
  SHARED_DOCS_TAB: 'shared-docs-tab',
  SIGNED_DOCS_TAB: 'signed-docs-tab',
  UPLOADED_DOCS_TAB: 'uploaded-docs-tab',
  DOCUMENTS_TABLE: 'documents-table',
} as const;

// Territories Tour Class Names
export const TERRITORIES_TOUR_CLASSES = {
  PAGE_HEADER: 'territories-page-header',
  MAP_CONTAINER: 'territories-map-container',
  MAP_EXPAND_BUTTON: 'map-expand-button',
  SEARCH_INPUT: 'territories-search-input',
  BY_STATE_CONTAINER: 'territories-by-state-container',
  STATE_VIEW_BUTTON: 'state-view-button',
  TERRITORY_ITEM_ROW: 'territory-item-row',
  TERRITORY_EXPAND_BUTTON: 'territory-expand-button',
  TERRITORY_DEMOGRAPHIC_SECTION: 'territory-demographic-section',
  TERRITORY_LIKE_BUTTON: 'territory-like-button',
  TERRITORY_RESERVE_BUTTON: 'territory-reserve-button',
} as const;
